import React from 'react';
import { Box, Button, Drawer, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { networkConfig } from 'config';
import WalletIcon from '@mui/icons-material/Wallet';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { appActions } from 'store/app';
import { NetworkTitle } from 'components/WalletDialog/NetworkTitle';
import { useAptosWalletContext } from 'context/aptosProvider';

const Row = styled('div')`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

const LaunchButton = styled(Button)(({}) => ({
	backgroundColor: '#345CF8',
	width: '100%',
	whiteSpace: 'nowrap',
	color: '#FFFFFF',
	padding: '12px 10px',
	fontFamily: 'AtAmiga',
	fontWeight: 600,
	fontSize: '14px',
	letterSpacing: '0.15em',
	textTransform: 'uppercase',
	boxShadow: 'none',
	clipPath:
		'polygon(15px 0, 100% 0, 100% calc(100% - 15px), calc(100% - 15px) 100%, 0 100%, 0 15px)',
	'&:hover': {
		backgroundColor: '#2a4be0',
		boxShadow: 'none',
	},
}));

const DisconnectButton = styled(Button)(({}) => ({
	backgroundColor: '#8A8C92',
	width: '100%',
	whiteSpace: 'nowrap',
	color: '#FFFFFF',
	padding: '12px 10px',
	fontFamily: 'AtAmiga',
	fontWeight: 600,
	fontSize: '14px',
	letterSpacing: '0.15em',
	textTransform: 'uppercase',
	boxShadow: 'none',
	clipPath:
		'polygon(15px 0, 100% 0, 100% calc(100% - 15px), calc(100% - 15px) 100%, 0 100%, 0 15px)',
	'&:hover': {
		backgroundColor: '#707277',
		boxShadow: 'none',
	},
}));

export const ConnectionButton = () => {
	const appState = useSelector((state: RootState) => state.app);
	const dispatch = useDispatch();
	const selectedVault = useSelector((state: RootState) => state.vault);
	const { account, balance, disconnect, isConnected } =
		useAptosWalletContext();
	const mainNet = Object.values(networkConfig);

	const addr = account ? account : '';

	console.log(account, balance, 'lpp99', isConnected);

	const toggleDrawer = (Open: boolean) => (event: any) => {
		if (
			event.type === 'keydown' &&
			(event.key === 'Tab' || event.key === 'Shift')
		) {
			return;
		}

		dispatch(appActions.openDrawer(Open));
	};

	/*const fetchBalance = useCallback(async () => {
		try {
			if (address) {
				const assetContract = getErc20Contract(
					selectedAsset?.address || '',
					signer?.provider.getSigner(address),
				);
				const assetBalance = await assetContract.balanceOf(address);
				setBalance(
					formatUnits(assetBalance, selectedAsset?.decimalValue),
				);
			} else {
				setBalance('0');
			}
		} catch (e) {
			//
		}
	}, [address, signer, selectedAsset?.address, selectedAsset?.decimalValue]);*/

	const ConnectedPanel = () => {
		return (
			<>
				<Typography
					variant={'subtitle2'}
					color={'#777'}
					fontWeight={500}
				>
					Choose a Network
				</Typography>
				<Box height={16} />
				{mainNet.map((d, index) => (
					<NetworkTitle key={index} {...d} />
				))}

				<Box height={64} />

				<LaunchButton
					onClick={() => {
						dispatch(appActions.openWallet(true));
					}}
					sx={{
						height: 42,
					}}
					variant="contained"
					fullWidth
					color="primary"
				>
					<Typography
						variant={'button'}
						fontWeight="bold"
						py="6px"
						color={'#fff'}
						style={{ lineHeight: '120%' }}
					>
						{`Connect`.toUpperCase()}
					</Typography>
				</LaunchButton>
			</>
		);
	};

	const DisconnectedPanel = () => {
		return (
			<>
				<Row>
					<Row style={{ justifyContent: 'flex-start' }}>
						<WalletIcon sx={{ color: '#333' }} />
						<Box width={10} />
						<abbr
							title={addr?.toString()}
							style={{
								display: 'contents',
								textDecoration: 'none',
							}}
						>
							<Typography variant={'caption'}>
								{addr?.slice(0, 5)}...
								{addr?.slice(addr.length - 5, addr.length)}
							</Typography>
						</abbr>
					</Row>
				</Row>
				<Box height={20} />
				<Typography variant={'h6'} fontWeight={600} color={'#999'}>
					{selectedVault.currency}&nbsp;
					{balance}
				</Typography>
				<Box height={32} />
				<Typography
					variant={'caption'}
					color={'#777'}
					display={'block'}
				>
					Choose a Network
				</Typography>
				<Box height={5} />
				{mainNet.map((d, index) => (
					<NetworkTitle key={index} {...d} />
				))}
				<Box height={30} />
				<Box height={16} />
				<DisconnectButton
					onClick={() => {
						disconnect();
					}}
					sx={{
						height: 42,
					}}
					variant="contained"
					fullWidth
				>
					<Typography
						variant={'button'}
						fontWeight="bold"
						py="6px"
						color={'#fff'}
						style={{ lineHeight: '120%' }}
					>
						{`Disconnect`.toUpperCase()}
					</Typography>
				</DisconnectButton>
			</>
		);
	};

	/*	useEffect(() => {
		fetchBalance();
	}, [fetchBalance]);*/

	const drawerContent = (
		<Box
			sx={{ width: 300, padding: 1.3, paddingTop: 3 }}
			role="presentation"
			onKeyDown={toggleDrawer(false)}
		>
			{!account && <ConnectedPanel />}
			{account && <DisconnectedPanel />}
		</Box>
	);

	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			{!account && (
				<LaunchButton onClick={toggleDrawer(true)}>
					{`Connect`.toUpperCase()}
				</LaunchButton>
			)}
			{account && (
				<LaunchButton onClick={toggleDrawer(true)}>
					{addr.slice(0, 3)}...
					{addr.slice(addr.length - 3, addr.length)}
				</LaunchButton>
			)}
			<Drawer
				anchor="right"
				open={appState.isDrawerOpen}
				onClose={toggleDrawer(false)}
				style={{ zIndex: 4000 }}
			>
				{drawerContent}
			</Drawer>
		</div>
	);
};
